import React, { createContext, ReactNode, useEffect } from "react";
import useStore from "../../hooks/useStore";
import { Store } from "../../types/StoreType";
import { useOrderStatus } from "../../hooks/useSharedContext";
import { useColesProjectLogout } from "../../hooks/useColesProjectLogout";

const defaultProviderValue: Store | undefined = undefined;

const StoreContext = createContext(defaultProviderValue as Store | undefined);

const StoreProvider = ({ children }: { children: ReactNode }) => {
  const { loginSuccessful, onClearOrders } = useOrderStatus();
  const { store, refreshStore } = useStore(loginSuccessful);

  useEffect(() => {
    if (loginSuccessful) {
      refreshStore();
    }
  }, [loginSuccessful, refreshStore]);

  // Detect Coles project users and force logout to redirect them to custom Coles Hello Screens
  // TODO: Remove this once Coles migration is complete
  useColesProjectLogout(store, onClearOrders);

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};

export { StoreContext, StoreProvider };
